import {Component, Input, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {LookupService} from "../../srvs/lookup";
import {RegionAuditLogsComponent} from "./regionAuditLogs.component";

@Component({
  selector: 'micro-sa-region-detail',
  templateUrl: './sa-region-detail.component.html'
})
export class SaRegionDetailComponent extends BaseComponent {

  @Input()
  regionId: any;

  region: any;
  saUsers: any[] = [];
  userCriteria = 'assignableUsers';

  @ViewChild("auditLogs", {static: false}) auditLogsComponent: RegionAuditLogsComponent;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router: Router,
              public authService: AuthService,
              private lookupService: LookupService,
              private alertService: AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    if (this.regionId) {
      this.loadId(this.regionId);
    } else {
      this.route.params.subscribe((params: Params) => {
        let id: any = params['id'];
        if (id !== '0') {
          this.loadId(id);
        }
      });
    }

  }

  loadId(id) {
    this.http.get(`${this.env.e.url}/domain/regions/${id}`).subscribe(
      data => {
        this.setRegion(data as any);
      }
    );
  }

  userCriteriaChanged($event) {
    if ($event !== this.userCriteria) {
      this.userCriteria = $event;
      this.loadSaUsers();
    }
  }

  setRegion(region: any) {
    this.region = region;
    this.loadSaUsers();
  }

  loadSaUsers() {
    var params: HttpParams = new HttpParams();
    if (this.userCriteria === 'assignableUsers' && this.authService.isCompanyAdmin()) {
      params = params.set("cId", this.region.companyId);
    }
    this.http.get(`${this.env.e.url}/auth/users/service/SITE_ACCESS`, {params: params}).subscribe(
      data => {
        let users = data as any[];
        for (let user of users) {
          user.department = this.lookupService.lookup("auth", "departments", user.departmentId, "");
          user.plDisplayName = `${user.department} / ${user.username} (${user.firstName} ${user.lastName})`;
        }
        this.saUsers = users;
      }
    );
  }

  save() {
    this.http.post(`${this.env.e.url}/domain/regions/${this.region.id}/users`, this.region.users)
      .subscribe(
        data => {
          this.alertService.info(`Updated ${this.region.name}`);
        }
      );
  }

}
